import './App.css';
import { BrowserRouter, Routes, Route, Link, Outlet, Navigate} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router';
import { useProfile, useNostr,useNostrEvents } from "nostr-react";
import { useRef , useEffect} from "react";
import React, {useState} from 'react'
import {nip19} from "nostr-tools";
import {default as ReactMarkdown, uriTransformer} from 'react-markdown'
import remarkGfm from 'remark-gfm'
import Collapsible from 'react-collapsible';
import i18next from 'i18next';
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { useTranslation } from 'react-i18next';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: true,
    interpolation: {
      escapeValue: false
    },
    resources: {
      en: {
        translation: {
          "ページ":"Page",
          "編集":"Edit",
          "編集履歴":"History",
          "不正なノートIDです":"Invalid note id",
          "ロード中":"Loading",
          "新しいページですか？":"New page?",
          "編集しましょう":"Edit it",
          "最終更新: ":"Last edit: ",
          "更新者: ":"by: ",
          "原版: ":"Base version: ",
          "新規ページ":"New page!",
          "新しいページを作ってリンクを追加":"Create new page and insert link to the page here",
          "保存":"Save",
"ページを見る":"See the contents",
"ソースを見る":"See the source",
          "トップ": "Top",
          "設定":"Settings",
          "秘密鍵設定: ":"Secret key settings: ",
          "毎回ランダムな鍵を使う":"Always use one time generated key",
          "初回に鍵を生成してそれを使い続ける":"Generate key if you don't have",
          "設定済みの鍵を使う":"Use existing key",
          "NIP-07鍵を使う":"Use NIP-07 API",
          "秘密鍵: ":"Secret key: ",
        }
      },
      ja: {
        translation: {
          
        }
      }
    }
  });

function myUriTransformer(uri) {
  const m = uri.match(/nostr:(note1[0-9a-z]*)/);
  if (m) {
    return "/nostrwiki/page/" + m[1];
  }
  return uriTransformer(uri);
}

function usePage() {
  const {noteid} = useParams();
  const decodedNoteId = nip19.decode(noteid);
  const edits = useNostrEvents({
    filter: {
      '#e': [ decodedNoteId.data ],
      kinds: [1],
      limit: 10,
    }
  }).events.map((page)=>{
    if (!page.tags.some((tag)=>
      tag[0]==='e'&&
      tag[1]===decodedNoteId.data&&
      tag[3]==='reply')) {
      return null;
    }
    const m = page.content.match(
      /^wikipage: ([^\n]+)\nbase: ([^\n]*)\ntitle: ([^\n]+)((\n.*)*?)\n---\n(.*)$/s);
    if (!m) {
      return null;
    }
    page = JSON.parse(JSON.stringify(page));
    page.wikiurl = m[1];
    page.wikibase = m[2];
    page.wikititle = m[3];
    page.wikipage = m[6];
    return page;
  }).filter((page)=>page);
  return {
    noteid,
    decodedNoteId,
    edits,
  }
}

function FormatTime(props) {
  const {timestamp} = props;
  return (
    <>
    { new Date(timestamp*1000+60*60*9*1000).toISOString().replace("Z","+0900") } 
    </>
  );
}

function UserName(props) {
  const {pubkey} = props;
  const { data: userData } = useProfile({
    pubkey,
  });

  if (userData) {
    return (
      <>
        {userData.name}
      </>
    );
  }
  return (
    <>
      ヽ(´ー｀)ノ {pubkey.slice(0,3)}
    </>
  );
}

function Title(props) {
  const {text} = props;
  useEffect(() => {
    document.title = text + " - NostrWiki";
  });
  return <h1>{text}</h1>;
}

function Page(props) {
  const {t} = useTranslation();
  // TODO: Find a way to factor out common part.
  const {
    noteid,
    decodedNoteId,
    edits,
  } = usePage();
  if (decodedNoteId.type !== 'note') {
    return <Title text={t("不正なノートIDです")}/>
  }
  if (edits.length < 1) {
    return (
      <div>
        <Title text={t("ロード中")}/>
        {t("新しいページですか？")}<Link to={"/edit/"+noteid}>{t("編集しましょう")}</Link>
      </div>
    )
  }
  // End of common part.
  const page = edits[0];
  return (
    <>
      <div className="topbar">
        <span>{t("ページ")}</span>
        <Link to={"/edit/" + noteid}>{t("編集")}</Link>
        <Link to={"/history/" + noteid}>{t("編集履歴")}</Link>
      </div>
      <div className="content">
        <Title text={page.wikititle}/>
        <div className="edit">
          {t("最終更新: ")}<FormatTime timestamp={page.created_at} />
          　
          {t("更新者: ")}<UserName pubkey={page.pubkey} />
        </div>
        <hr />
        <div>
          <ReactMarkdown children={page.wikipage} remarkPlugins={[remarkGfm]} transformLinkUri={myUriTransformer} />
        </div>
      </div>
    </>
  );
}

function Edit(props) {
  const {t} = useTranslation();
  const [newTitle, setNewTitle] = useState(undefined);
  const [newText, setNewText] = useState(undefined);
  const navigate = useNavigate();
  const { publish } = useNostr();
  const textarea = useRef(null);
  const {store} = props;
  // TODO: Find a way to factor out common part.
  const {
    noteid,
    decodedNoteId,
    edits,
  } = usePage();
  if (decodedNoteId.type !== 'note') {
    return <Title text={t("不正なノートIDです")}/>
  }
  // End of common part.
  const page = edits[0];
  if (page && newText === undefined) {
    setNewText(page.wikipage);
  }
  if (page && newTitle === undefined) {
    setNewTitle(page.wikititle);
  }
  async function save(e) {
    const base = (page ? (
      nip19.noteEncode(page.id)
    ) : (
      "null"
    ));
    const content = "wikipage: https://test.ikeji.ma/nostrwiki/page/" + noteid + "\n" +
      "base: " + base + "\n" +
      "title: " + newTitle.replaceAll("\n","") + "\n" +
      "---\n" + newText;
    const message = {
      kind: 1,
      created_at: Math.floor(Date.now() / 1000),
      tags: [
        [ "e",
          decodedNoteId.data,
          "",
          "reply"
        ]
      ],
      content,
    };
    const signedMessage = await store.signMessage(message);
    if (!signedMessage) {
      return;
    }
    publish(signedMessage);
    navigate("/page/"+noteid);
  }
  async function insertNewPage(e) {
    const message = {
      kind: 1,
      created_at: Math.floor(Date.now() / 1000),
      tags: [],
      content: "A fresh new page in nostr wiki. \n https://test.ikeji.ma/nostrwiki/",
    };
    const signedMessage = await store.signMessage(message);
    if (!signedMessage) {
      return;
    }
    publish(signedMessage);
    var len      = newText.length;
    var pos      = textarea.current.selectionStart;

    var before   = newText.substr(0, pos);
    var link = '[new page](nostr:' + nip19.noteEncode(signedMessage.id) + ")";
    var after    = newText.substr(pos, len);

    setNewText(before + link + after);
  }
  return (
    <>
      <div className="topbar">
        <Link to={"/page/" + noteid}>{t("ページ")}</Link>
        <span>{t("編集")}</span>
        <Link to={"/history/" + noteid}>{t("編集履歴")}</Link>
      </div>
      <div className="content">
        <div style={{display: "none"}}>
          <Title text={newTitle}/>
        </div>
        <h1>
          <input value={newTitle}
                 onChange={(e)=>setNewTitle(e.target.value)} />
        </h1>
        { page ? 
          <div className="edit">
            {t("原版: ")}<FormatTime timestamp={page.created_at} />
            　
            {t("更新者: ")}<UserName pubkey={page.pubkey} />
          </div>
          :
          <div>
            {t("新規ページ")}
          </div>
        }
        <hr />
        <div className="editor">
          <div>
            <button onClick={insertNewPage}>{t("新しいページを作ってリンクを追加")}</button>
            <textarea
              ref={textarea}
              value={newText}
              onChange={(e)=>setNewText(e.target.value)} />
          </div>
          <div>
            <ReactMarkdown children={newText} remarkPlugins={[remarkGfm]} transformLinkUri={myUriTransformer} />
          </div>
        </div>
        <button onClick={save}>{t("保存")}</button>
      </div>
    </>
  );
}

function History(props) {
  const {t} = useTranslation();
  // TODO: Find a way to factor out common part.
  const {
    noteid,
    decodedNoteId,
    edits,
  } = usePage();
  if (decodedNoteId.type !== 'note') {
    return <Title text={t("不正なノートIDです")}/>
  }
  if (edits.length < 1) {
    return <Title text={t("ロード中")}/>
  }
  // End of common part.
  const latest = edits[0];
  return (
    <>
      <div className="topbar">
        <Link to={"/page/" + noteid}>{t("ページ")}</Link>
        <Link to={"/edit/" + noteid}>{t("編集")}</Link>
        <span>{t("編集履歴")}</span>
      </div>
      <div className="content">
        <Title text={t("編集履歴")+": "+latest.wikititle}/>
        <hr />
        <div>
          <ul>
          {
            edits.map((edit)=>(
              <li key={edit.id}>
                title: {edit.wikititle} <br/>
                date: <FormatTime timestamp={edit.created_at} /> <br/>
                by: <UserName pubkey={edit.pubkey} />
                <Collapsible trigger={t("ページを見る")}>
                  <ReactMarkdown children={edit.wikipage} remarkPlugins={[remarkGfm]} transformLinkUri={myUriTransformer} />
                </Collapsible>
                <Collapsible trigger={t("ソースを見る")}>
                  <pre>{edit.wikipage}</pre>
                </Collapsible>
              </li>
            ))
          }
          </ul>
        </div>
      </div>
    </>
  );
}

function LeftBar(props) {
  const {t} = useTranslation();
  const {store} = props;
  return (
    <div className="left">
      <div className="logo">N</div>
      <hr />
      <Link to={"/page/"+store.homepage}>
        {t("トップ")}
      </Link><br/>
      <Link to={"/config"}>
        {t("設定")}
      </Link><br/>
    </div>
  );
}

function Footer(props) {
  const {t} = useTranslation();
  const {store} = props;
  const [inputType, setInputType] = useState("password");
  return (
    <div className="content">
      <Title text={t("設定")}/>
      {t("秘密鍵設定: ")}
      <select value={store.secretKeyMode}
              onChange={(e)=>store.updateSecretKeyMode(e.target.value)}>
        <option value="a">{t("毎回ランダムな鍵を使う")}</option>
        <option value="b">{t("初回に鍵を生成してそれを使い続ける")}</option>
        <option value="c">{t("設定済みの鍵を使う")}</option>
        <option value="d">{t("NIP-07鍵を使う")}</option>
      </select>
      <br />
      {t("秘密鍵: ")}
      <input type={inputType}
             value={store.secretKey}
             onChange={(e)=>store.updateSecretKey(e.target.value)}
             onFocus={(e)=>setInputType("text")}
             onBlur={(e)=>setInputType("password")} />
    </div>
  )
}

function App(props) {
  const {store} = props;
  return (
    <div className="App">
      <BrowserRouter basename="/nostrwiki/">
        <Routes>
          <Route path="/" element={
            <>
              <LeftBar store={store} />
              <div className="main">
                <Outlet />
              </div>
            </>
          }>
            <Route path="" element={
              <Navigate replace to={"/page/"+store.homepage} />
            } />
            <Route path="page/:noteid" element={
              <Page store={store} />
            } />
            <Route path="edit/:noteid" element={
              <Edit store={store} />
            } />
            <Route path="history/:noteid" element={
              <History store={store} />
            } />
            <Route path="config" element={
              <Footer store={store}/>
            } />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}


export default App;
